module.exports = __webpack_public_path__ + "img/nzavo-main.90c12583.jpg";